/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import DisplayTime from "./DateTime/DisplayTime.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";

class History extends Component {
    constructor() {
        super();

        this.scrollRef = React.createRef()
    }

    componentDidMount() {
        setTimeout(() => {
            let element = this.scrollRef.current
            if (element !== null) {
                element.scrollTop = element?.scrollHeight ?? 0;
            }
        }, 200)
    }


    render() {

        let {elements} = this.props

        return (
            <div className={" w-full h-full max-h-96 overflow-scroll customScrollbarSmall space-y-2 p-2 bg-white"}
                 ref={this.scrollRef}>
                <ul role="listCommand" className="space-y-6">
                    {elements.map(element => {
                        return <li className="relative flex gap-x-4">
                            <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                                <div className="w-px bg-gray-200"/>
                            </div>
                            {((element.iconName ?? "") !== "") ? (<>
                                <div className="relative flex h-6 w-6 flex-none items-center justify-center ">
                                    <DisplayIcon iconName={element.iconName} className="h-6 w-6 text-indigo-600"/>

                                </div>

                            </>) : (<>
                                <div className="relative flex h-6 w-6 flex-none items-center justify-center ">
                                    <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"/>
                                </div>
                            </>)}


                            <div className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                                {element.text}
                                {/*<span*/}
                                {/*    className="font-medium text-gray-900">Chelsea Hagon</span> created the invoice.*/}
                            </div>
                            <time dateTime="2023-01-23T10:32"
                                  className="flex-none py-0.5 text-xs leading-5 text-gray-500"><DisplayTime
                                value={element.timestamp * 1000}/>
                            </time>
                        </li>

                    })}


                    {/*<li className="relative flex gap-x-4">*/}
                    {/*    <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">*/}
                    {/*        <div className="w-px bg-gray-200"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">*/}
                    {/*        <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"/>*/}
                    {/*    </div>*/}
                    {/*    <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500"><span*/}
                    {/*        className="font-medium text-gray-900">Chelsea Hagon</span> edited the invoice.</p>*/}
                    {/*    <time dateTime="2023-01-23T11:03"*/}
                    {/*          className="flex-none py-0.5 text-xs leading-5 text-gray-500">6d ago*/}
                    {/*    </time>*/}
                    {/*</li>*/}
                    {/*<li className="relative flex gap-x-4">*/}
                    {/*    <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">*/}
                    {/*        <div className="w-px bg-gray-200"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">*/}
                    {/*        <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"/>*/}
                    {/*    </div>*/}
                    {/*    <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500"><span*/}
                    {/*        className="font-medium text-gray-900">Chelsea Hagon</span> sent the invoice.</p>*/}
                    {/*    <time dateTime="2023-01-23T11:24"*/}
                    {/*          className="flex-none py-0.5 text-xs leading-5 text-gray-500">6d ago*/}
                    {/*    </time>*/}
                    {/*</li>*/}
                    {/*<li className="relative flex gap-x-4">*/}
                    {/*    <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">*/}
                    {/*        <div className="w-px bg-gray-200"/>*/}
                    {/*    </div>*/}
                    {/*    <img*/}
                    {/*        src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"*/}
                    {/*        alt="" className="relative mt-3 h-6 w-6 flex-none rounded-full bg-gray-50"/>*/}
                    {/*    <div className="flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200">*/}
                    {/*        <div className="flex justify-between gap-x-4">*/}
                    {/*            <div className="py-0.5 text-xs leading-5 text-gray-500"><span*/}
                    {/*                className="font-medium text-gray-900">Chelsea Hagon</span> commented*/}
                    {/*            </div>*/}
                    {/*            <time dateTime="2023-01-23T15:56"*/}
                    {/*                  className="flex-none py-0.5 text-xs leading-5 text-gray-500">3d ago*/}
                    {/*            </time>*/}
                    {/*        </div>*/}
                    {/*        <p className="text-sm leading-6 text-gray-500">Called client, they reassured me the*/}
                    {/*            invoice would be paid by the 25th.</p>*/}
                    {/*    </div>*/}
                    {/*</li>*/}
                    {/*<li className="relative flex gap-x-4">*/}
                    {/*    <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">*/}
                    {/*        <div className="w-px bg-gray-200"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">*/}
                    {/*        <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"/>*/}
                    {/*    </div>*/}
                    {/*    <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500"><span*/}
                    {/*        className="font-medium text-gray-900">Alex Curren</span> viewed the invoice.</p>*/}
                    {/*    <time dateTime="2023-01-24T09:12"*/}
                    {/*          className="flex-none py-0.5 text-xs leading-5 text-gray-500">2d ago*/}
                    {/*    </time>*/}
                    {/*</li>*/}
                    {/*<li className="relative flex gap-x-4">*/}
                    {/*    <div className="absolute left-0 top-0 flex w-6 justify-center h-6">*/}
                    {/*        <div className="w-px bg-gray-200"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">*/}
                    {/*        <svg className="h-6 w-6 text-indigo-600" viewBox="0 0 24 24" fill="currentColor"*/}
                    {/*             aria-hidden="true">*/}
                    {/*            <path fillRule="evenodd"*/}
                    {/*                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"*/}
                    {/*                  clipRule="evenodd"/>*/}
                    {/*        </svg>*/}
                    {/*    </div>*/}
                    {/*    <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500"><span*/}
                    {/*        className="font-medium text-gray-900">Alex Curren</span> paid the invoice.</p>*/}
                    {/*    <time dateTime="2023-01-24T09:20"*/}
                    {/*          className="flex-none py-0.5 text-xs leading-5 text-gray-500">1d ago*/}
                    {/*    </time>*/}
                    {/*</li>*/}
                </ul>
            </div>
        );
    }
}

History.propTypes = {};

History.defaultProps = {};


export default History;